import React from "react"

import { DateRangePicker } from "@/components/ui/date-range-picker"
import type { DateRange } from "@/types/trade"
import type {
  DashboardDatePresetTimeframe,
  DashboardDateRangeChangeOptions,
} from "@/utils/dashboardDateWindowStorage"

interface StatisticsHeaderDateRangePickerProps {
  dateRange: DateRange
  onDateRangeChange: (
    dateRange: DateRange,
    options?: DashboardDateRangeChangeOptions
  ) => void
  selectedPresetId?: DashboardDatePresetTimeframe | null
  comparisonEnabled: boolean
  onComparisonEnabledChange: (enabled: boolean) => void
  comparisonRange: DateRange | null
  onComparisonRangeChange: (range: DateRange | null) => void
}

/** Statistics inset header date picker with optional period comparison. */
export function StatisticsHeaderDateRangePicker({
  dateRange,
  onDateRangeChange,
  selectedPresetId = null,
  comparisonEnabled,
  onComparisonEnabledChange,
  comparisonRange,
  onComparisonRangeChange,
}: StatisticsHeaderDateRangePickerProps): React.ReactElement {
  return (
    <DateRangePicker
      dateRange={dateRange}
      onDateRangeChange={onDateRangeChange}
      selectedPresetId={selectedPresetId}
      emptyLabel="All time"
      comparisonEnabled={comparisonEnabled}
      onComparisonEnabledChange={onComparisonEnabledChange}
      comparisonRange={comparisonRange}
      onComparisonRangeChange={onComparisonRangeChange}
    />
  )
}

export default StatisticsHeaderDateRangePicker
